export default __webpack_public_path__ + "static/media/Group24.91635d46.png";